<template lang="html">
  <section class="is-light section">
    <div class="container-fluid">
      <div>
        <header class="card-header">Email Attachment</header>   
      </div>  
        <div class="card-content">
          <table class="table table-fixed table-hover table-bordered tableFixHeadBottom table-text-cente"  v-if="attachmentpaths.length">
            <thead class="table-head"> 
              <tr>
                <th>Attachment of Case ID : {{caseid}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(path,index) in attachmentpaths" :key="index">
                <td>
                 <button type="button" class="btn btn-link px-0" @click="getSignedUrl(path.filename)">{{path.filename}}</button>
                </td>
              </tr>
            </tbody>
        </table>
       </div>
    </div>
  </section>
</template>

<script>
//import CONSTANTS from '@/utils/constants'
import apiUrl from '../../../constants'
import axios from 'axios'
import commonFunction from '../../../commonFunction'
export default {
  name: 'emailattachment',
  props: ['inboxID', 'caseID'],
  data: () => ({
    inboxid: '',
    attachmentpaths: [],
    isShowAttachment: false,
    caseid: '',
    isActiveLogModal: false
  }),
  created () {
    // console.log( 'created' );
    this.inboxid = this.$route.query.inboxID
    this.outboxid = this.$route.query.outboxID
    this.caseid = this.$route.query.caseID
    // console.log('inboxid : '+this.inboxid+' outboxid : '+this.outboxid);
    this.getAttachmentPath()
  },
  methods: {
    // On page load will get all attachmentpaths of caseid based on inboxid
    getAttachmentPath () {
      this.attachmentpaths = []
      let getAttachmentPathObj = {
        caseid: this.caseid,
        type : (this.inboxid !== undefined ) ? 'in' : 'out',
        id : (this.inboxid !== undefined ) ? this.inboxid : this.outboxid
      }
      if (this.caseid) {
        return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getallattachments',
          headers: commonFunction.getusertoken(),
          'data': getAttachmentPathObj
        }).then((result) => {             
            if (result.data && result.data.length) {
              result.data.forEach((inbox) => {
                // console.log( 'inbox : '+JSON.stringify( inbox ) );              
              
                if (inbox.emailattachments) {
                   for (let attachment of inbox.emailattachments) {
                       this.attachmentpaths.push(attachment)
                   }   
                }
              })
            }
          }).catch((httpException) => {
            return this.$alertify.error( httpException.message )
          })
      }
   
    },
    getSignedUrl: function (filename) {
      // console.log( 'inboxid : '+this.inboxid );
      let sendKey = {};
      if( this.inboxid !== undefined ) {
         sendKey.inboxId = this.inboxid;
         sendKey.s3urlKey = `Attachment/${this.caseid}/${filename}`
      } else {
         sendKey.inboxId = '';
         sendKey.s3urlKey = `Attachment/outbox/${this.caseid}/${filename}`  
      }  
      return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getsignedurl',
          headers: commonFunction.getusertoken(),
          'data': sendKey
        }).then((response) => {           
          window.open(response.data.url, '_blank')
        })
        .catch((httpException) => {
          return this.$alertify.error( httpException.message )
        })
    }
  }
}
</script>

<style lang="css" scoped="">
.previewModal {
  width:85% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/emailattachment.vue?cc449c0e